import { CardMedia, CircularProgress, Grid } from '@mui/material';

const ScreenLoader = () => {
  return (
    <>
      <Grid container height='100vh' justifyContent='center' alignItems='center' flexDirection='column' rowGap={4}>
        <CardMedia
          component='img'
          image='/images/logos/paynet/Paynet-logo.png'
          alt='Logo Paynet'
          sx={{
            maxHeight: '15em',
            maxWidth: '15em',
            animation: 'pulse 1.4s infinite ease-in-out',
            '@keyframes pulse': {
              '0%': {
                transform: 'scale(0.95)',
              },

              '70%': {
                transform: 'scale(1)',
              },

              '100%': {
                transform: 'scale(0.95)',
              },
            },
          }}
        />
        <CircularProgress size={45} sx={{ color: '#EA0029' }} />
      </Grid>
    </>
  );
};

export default ScreenLoader;
